module.exports = __webpack_public_path__ + "img/item_link_packaging@2x.b8d8b57.jpg";